module.exports = __webpack_public_path__ + "static/media/Group92.d8465a72.png";